module.exports = __webpack_public_path__ + "img/fk.9274a002.svg";